import { useContext } from "react";
import Separator from "components/shared/Separator";
import { Context } from "Context";

const mainClass = "syndicated-footer__disney-reservation-center";
const DisneyReservationCenter = ({ title, subtitle, footer }) => {
	const {
		config: { brand, locale },
	} = useContext(Context);

	return title || subtitle || footer ? (
		<div className={mainClass} data-nosnippet>
			<Separator section="footer" hideInMobile />
			<ul className={`${mainClass}__container`}>
				{title && (
					<li
						className={`${mainClass}__container__title ${mainClass}__container__title--${brand}--${locale}`}
						dangerouslySetInnerHTML={{ __html: title }}
					></li>
				)}
				{subtitle && (
					<li
						className={`${mainClass}__container__subtitle ${mainClass}__container__subtitle--${brand}--${locale}`}
						dangerouslySetInnerHTML={{ __html: subtitle }}
					></li>
				)}
				{footer && (
					<li
						className={`${mainClass}__container__footer ${mainClass}__container__footer--${brand}--${locale}`}
						dangerouslySetInnerHTML={{ __html: footer }}
					></li>
				)}
			</ul>
			<Separator section="footer" hideInMobile />
		</div>
	) : null;
};

export default DisneyReservationCenter;
